<script>
import { mapGetters } from 'vuex';
import MeetingEventNumber from './MeetingEventNumber.vue';
export default {
  name: 'FormGuideMeetingHeaderMobile',
  components: {
    MeetingEventNumber,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
    activeEventNumber: {
      type: String,
      required: true,
    },
    activeView: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dropdownOpen: false,
      selected: '',
    };
  },
  computed: {
    ...mapGetters({
      meeting: 'FormGuideMeetingHeader/getMeetingData',
      meetings: 'FormGuideMeetingHeader/getMeetingsData',
    }),
    meetingData() {
      return this.meeting || {};
    },
    meetingEvents() {
      const { meetingData } = this;
      return meetingData.events
        ? meetingData.events.sort((a, b) => {
            return a.event_number - b.event_number;
          })
        : [];
    },
    meetingsGroup() {
      return this.meetings || [];
    },
  },
  mounted() {
    this.selected = this.slug;
  },
};
</script>

<template>
  <div class="fg-meeting-header-mobile">
    <div class="fg-meeting-header-mobile__container">
      <select v-model="selected" class="fg-meeting-header-mobile__dropdown">
        <optgroup
          v-for="(group, meetingDate) in meetingsGroup"
          :key="group.value"
          :label="meetingDate"
        >
          <option
            v-for="meeting in group"
            :key="meeting.slug"
            :value="meeting.slug"
            :selected="meeting.slug === selected"
          >{{ meeting.name }}</option>
        </optgroup>
      </select>
    </div>
    <div class="fg-meeting-header-mobile__events">
      <template v-for="(event, index) in meetingEvents">
        <MeetingEventNumber
          :key="`meeting-event-no-${index}`"
          :event-id="event.id"
          :event-number="event.event_number"
          :active-view="activeView"
          :active-event-number="activeEventNumber"
          :event-status="event.status"
          :prefix-text="false"
        />
      </template>
    </div>
  </div>
</template>
